module.exports = __webpack_public_path__ + "img/esg-3-3.3e30cc68.png";